/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const NAME = feature.getSettingValue('TEMP_NAME');
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
'Tibbit 00_3 with tibbit 29
select case tbt29_init("${NAME}",NO,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL_NUM)
case TBT29_WRONG_MFGID:
sys.debugprint("DEFAULT_MFGID_INCORRECT"+chr(10)+chr(13))
sys.halt

case TBT29_WRONG_DEVID_REVISION:
sys.debugprint("TBT29_WRONG_DEVID_REVISION"+chr(10)+chr(13))
sys.halt

case TBT29_NO_SSI_AVAILABLE:
sys.debugprint("SSI channel could not be allocated, using bit banging instead."+chr(10)+chr(13))

end select`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${NAME}_CHANNEL_NUM as byte
            `,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim ${NAME}_CHANNEL_NUM as byte
            `,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
'sys.debugprint(ftostr(tbt29_get_c(${NAME}_CHANNEL_NUM),FTOSTR_MODE_AUTO,4)+" C"+chr(10)+chr(13))`,
    });

    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `var_${NAME}_update_completed(tbt29_get_c(${NAME}_CHANNEL_NUM))`,
    });

    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const ${NAME}_CLK = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[0]}
const ${NAME}_DATA = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[1]}
                         `,
    });

    return blocks;
};
